import { useEffect, useRef } from "react";
import styled from "styled-components";

const VisuallyHiddenHeading = styled.h1`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

export const ScreenTitle = ({ name }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (!name) return undefined;
    const id = requestAnimationFrame(() => {
      ref.current?.focus({ preventScroll: true });
    });
    return () => cancelAnimationFrame(id);
  }, [name]);

  return (
    <VisuallyHiddenHeading ref={ref} tabIndex={-1} aria-label={name}>
      {name}
    </VisuallyHiddenHeading>
  );
};
